/** @jsx jsx */
import { jsx } from '@emotion/core';
// import React from 'react';
import { Container, Row, Column } from '../../../styles/Grid';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import DotComponent from '../../ui/DotComponent';
import Spacer from '../../ui/Spacer';
import { Icon } from '../../ui/Icon';
import * as styles from './index.styles';

import InputForm from './InputForm';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
class TalkToUs extends SafePureComponent {
  safeRender() {
    const { fields } = this.props;
    return (
      <Spacer customCss={styles.talktouscontentsholder}>
        <Container>
          <Row>
            <Column cols={{ sm: 6, md: 5, lg: 5, xl: 5 }}>
              <div className="backbutton">
                <div>
                  <h1>
                    {fields.Title.value}
                    <DotComponent />
                  </h1>
                </div>
              </div>
            </Column>
          </Row>

          <Row className="bottom_line">
            <Column
              className="leftside_sec"
              cols={{ sm: 6, md: 3, lg: 5, xl: 5 }}
            >
              <div className="leftsidearea">
                <div className="left_side">
                  <img
                    className="img_1"
                    src={fields.LeftImage.value.src}
                    alt={fields.Title.value}
                  />
                  <img
                    className="img_2"
                    src={fields.LeftImageForSmallerDevices.value.src}
                    alt={fields.Title.value}
                  />
                </div>
                <div className="needtotalktxt">
                  <h2>{fields.LeftHeading.value}</h2>
                  <p>{fields.LeftIntro.value}</p>

                  <div className="callno">
                    <a href="tel:0800 123 4567">
                      <span>
                        <Icon name="contact" className="phone-default-icon" />
                      </span>
                      <span className="numb">
                        {fields.LeftPhoneNumber.value}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </Column>
            <Column className="hrlinesec" cols={{ sm: 6, md: 1, lg: 1 }}>
              <div className="hrline"></div>
            </Column>
            <Column className="formarea" cols={{ sm: 6, md: 4, lg: 5 }}>
              <div className="formtxt">
                <h2>{fields.RightHeading.value}</h2>
                <p>{fields.RightIntro.value}</p>
              </div>

              <InputForm fields={fields} />

              <div className="privacypolicytxt">
                <RichText
                  className="agreetxt"
                  field={fields.PrivacyPolicyText}
                  tag="span"
                />
              </div>
            </Column>
          </Row>
        </Container>
      </Spacer>
    );
  }
}

TalkToUs.displayName = 'TalkToUs';

export default TalkToUs;
